import { BehaviorSubject, Observable, filter, skip } from 'rxjs';

export class FieldSubject<T> extends BehaviorSubject<T> {
    override asObservable(): Observable<T> {
        const observable: any = new Observable<T>();
        observable.source = this;
        return observable.pipe(skip(1)).pipe(filter(isNonNull));
    }
}

export function isNonNull<T>(value: T): value is NonNullable<T> {
    return value !== null && value !== undefined;
}
